export default __webpack_public_path__ + "static/char-07-81fb04066eaf1f8dedf2248135404a31.webp";